module.exports = __webpack_public_path__ + "img/logo.59cfd657.png";